<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow>
			<CCol>
				<b-form-file
					ref="prilogeInput"
					multiple
					v-model="tmpOrderAttachments"
					:placeholder="uploadPlaceholder"
					:file-name-formatter="placeholderText"
					drop-placeholder="Povleci datoteko..."
					browse-text="Brskaj"
					@input="uploadOrderAttachments"
					:accept="acceptedFormats"/>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
const PH_TEXT = 'Izberi ali povleci datoteko ...';

export default {
	name: 'sp-order-attachments-upload-modal',
	components: {
	},
	methods: {
		showModal: function () {
			this.title = 'Dodajanje priloge k naročilu';
			this.okButton.label = 'Dodaj';
			this.$refs.modal.show();
		},
		clearModalData: function () {
			this.tmpOrderAttachments = [];
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		placeholderText: function () {
			return PH_TEXT;
		},
		uploadOrderAttachments: function () {
			for (let attachment of this.tmpOrderAttachments) {
				if (attachment.size > 10485760) {
					this.showError('Datoteka ' + attachment.name + ' je prevelika!');
					return;
				}
			}
			this.$emit('emit_spOrderAttachmentsSelected', this.tmpOrderAttachments);
			this.$refs.modal.hide();
		}
	},
	data: function () {
		return {
			settings,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false,
				title: ''
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			tmpOrderAttachments: []
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			return 'md';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		acceptedFormats () {
			return '.pdf, .jpg, .jpeg, .png';
		},
		okButtonDisabled () {
			if (this.tmpOrderAttachments.length < 1) {
				this.okButton.title = 'Dodana mora biti vsaj ena datoteka';
				return true;
			}
			this.okButton.title = '';
			return false;
		}
	},
	created () {
	}
}
</script>

<style>
</style>
<style scoped>
.ma_pos {
	text-align: end;
}
</style>